import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import StripeCheckout from "react-stripe-checkout";
import { toast } from "react-toastify";
import Image from "react-bootstrap/Image";
import { Modal } from "react-bootstrap";
// import Bnc from '../Bnc.jpg';
// import MonCash from '../MonCash.jpg';
// import LajanCash from '../LajanCash.png';
import Button from "react-bootstrap/Button";
// import Mode_paiement from './Mode_paiement';
import { FaEdit } from "react-icons/fa";
import Bunexe_service from "../../../Bunexe_service";
// import { uniqueId } from "lodash";
// import { uuid } from "uuidv4";

const InfoTransaction = ({
  Info_personnelle,
  etapesuivante,

  montant_a_payer,
  etapeprecedente,
  methode_paiement,
  setMethode_paiement,
  valeurSelectionnee,
  date_trx,
  setDateTrx,
  id_trx,
  setIdTrx,
  orderId,
}) => {
  let url_ = Bunexe_service.url;
  const [show, setShow] = useState(false);
  const [my_iframe, setMyIframe] = useState("");
  const [moncash_url, setMonCashUrl] = useState(
    "http://sandbox.moncashbutton.digicelgroup.com/Moncash-middleware/Payment/Redirect?token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjQzMzA5IiwicmVmIjoiMTIzNDQ1NTY0NDU0NTQyMTIzIiwiY3J0IjoxNjQ2NjQ4MDQzMDE5LCJleHQiOjE2NDY2NDg2NDMwMTksImFwaSI6dHJ1ZX0.fUDqbpjzDP3YcCoM1taAwFBzeW10kL7oAELJ1De60_llPxQ1tkLbzyAzU3I-7CzTq5fKnnqoXWocemwegtfqM8Eru97OcD0VBHd2VjerEVAqLEYzumc6euCHfPCeqLXcuVoxXf4CNwTW9p0P1tPBtMA9WwtYHca76Rr61nU0hx5szhCGdos8vjnTiiKMne5GSSbUkUY6vhbMx5rI2rG6TPFNizkXa-wgyMbzfzCoVlshwZZ44IfSCgYIoT5IzRWclCMA6NE0kRyX3GmUbnTZ4OhbR813hzopYTEVaCIc-hrF72rgN5Rev0O6iHeztBVYi5xj-lliwUECmUYYYytXiQ"
  );
  const google =
    "<iframe width='100%' height='100%' scrolling='no' src='https://www.google.com/webhp?igu=1&gws_rd=ssl' sandbox='allow-modals allow-forms allow-popups allow-scripts allow-same-origin'></iframe>";

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitform = () => {
    localStorage.setItem("info", JSON.stringify(Info_personnelle));
    localStorage.setItem("montant", JSON.stringify(montant_a_payer));
    localStorage.setItem("valeur", JSON.stringify(valeurSelectionnee));
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ montant_a_payer: montant_a_payer }),
    };

    try {
      fetch(url_ + "/dossier/moncash/checkout", requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          // if (data.hasError) {
          //   toast.error(data.message, {
          //     position: toast.POSITION.TOP_RIGHT,
          //   });
          //   //afficherMessage(data.message);
          // } else {
          // console.log(data.moncash_url);
          //scrolling='no'
          console.log(data);
          if (data.succes == "False") {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            setMyIframe(
              `<iframe minWidth='400' height='600px' src={data.moncash_url} sandbox='allow-modals allow-forms allow-popups allow-scripts allow-same-origin'></iframe>`
            );
            setMonCashUrl(data.moncash_url);
            window.open(data.moncash_url, "_self");
            //handleShow();
          }

          // handleShow();
          // }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
    // alert(JSON.stringify(Form_data));
  };

  const submitform1 = () => {
    localStorage.setItem("info", JSON.stringify(Info_personnelle));
    localStorage.setItem("montant", JSON.stringify(montant_a_payer));
    localStorage.setItem("valeur", JSON.stringify(valeurSelectionnee));
    console.log(Info_personnelle);
    let e_diplome_trx = {
      order_id: orderId,
      nom_article: valeurSelectionnee,
      prix: montant_a_payer,
      nom: Info_personnelle.nom,
      identifiant_eleve: Info_personnelle.Identifiant,
      prenom: Info_personnelle.prenom,
      matricule: Info_personnelle.Matricule,
      annee_participation: Info_personnelle.Annee,
      telephone: "",
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(e_diplome_trx),
    };

    try {
      fetch(url_ + "/dossier/passer_commande", requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          console.log(data);
          if (data.msg == "NO_OK") {
            toast.error(" Problème d'enregistrement de Transaction", {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            etapesuivante();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
    // alert(JSON.stringify(Form_data));
  };

  const [product] = useState({
    name: valeurSelectionnee.replaceAll("_", " "),
    price: montant_a_payer,
    description: `vous avez placé une commande de ${valeurSelectionnee.replaceAll(
      "_",
      " "
    )}, le cout de cette commande est de ${montant_a_payer} gourdes`,
  });

  async function handleToken(token, addresses) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, product }),
    };

    const response = await fetch(url_ + `/dossier/checkout`, requestOptions);
    // const response = await axios.post("http://localhost:8080/checkout", {
    //   token,
    //   product,
    // });
    console.log(response.status);
    if (response.status === 200) {
      toast("Info Card de Credit Validé", { type: "success" });
      etapesuivante();
    } else {
      toast("Erreur, Reverifiez les Informations de la carte de Credit", {
        type: "error",
      });
    }
  }

  useEffect(() => {
    localStorage.setItem("info", JSON.stringify(Info_personnelle));
    localStorage.setItem("montant", JSON.stringify(montant_a_payer));
    localStorage.setItem("valeur", JSON.stringify(valeurSelectionnee));
  }, []);

  return (
    <div className="card mb-3">
      <div className="card-header">
        <h2 className="display-5 text-center mb-1">Info. Transaction</h2>
        {/* <h3 className="bg-red text-center mb-1">
          Module en cours de developpement
        </h3> */}
      </div>
      <div className="card-body">
        <div className="row d-flex justify-content-center">
          {methode_paiement == "credit_card" ||
          methode_paiement == "primature" ||
          methode_paiement === "moncash" ? (
            <>
              {/* <h3 className="text-center"> {valeurSelectionnee}</h3> */}
              <h4 className="text-center">
                {valeurSelectionnee.replaceAll("_", " ")}
              </h4>
              <h3 className="text-center">prix : {montant_a_payer} HTG</h3>

              <br />
              <div className="form-group container d-flex justify-content-center">
                {methode_paiement == "credit_card" && (
                  <StripeCheckout
                    className="center"
                    stripeKey="pk_test_51KZTWLEOpBelQNILckJiBjtgmor5osgkc7Updfu5lcA9RRhAyY4vSyXBQbdgGJAtpKhA1iXDeHxqGQupsxnukA6300IgN6ZpVt"
                    token={handleToken}
                    amount={montant_a_payer * 100}
                    name="MENFP e-diplôme"
                    billingAddress
                    shippingAddress
                  />
                )}
                {methode_paiement == "moncash" && (
                  <>
                    <button className="btn btn-danger" onClick={submitform}>
                      Mon Cash
                    </button>
                  </>
                )}
                {methode_paiement == "primature" && (
                  <>
                    <button className="btn btn-danger" onClick={submitform1}>
                      Sèvis Gratis
                    </button>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <Form>
                <div className="container">
                  <div>
                    {methode_paiement == "moncach" && (
                      <h2 className="text-center">
                        {` Methode de Paiement ${
                          methode_paiement === "moncach"
                            ? "MonCach"
                            : methode_paiement === "lajancach"
                            ? "LajanCash"
                            : "NatCash"
                        }`}

                        <FaEdit size={30} onClick={etapeprecedente} />
                      </h2>
                    )}
                  </div>
                  <hr />
                  <Form.Row>
                    <div className="form-group">
                      <label htmlFor="date_trx">Date Transaction</label>
                      <input
                        type="date"
                        className="form-control"
                        id="date_trx"
                        placeholder="Date Transaction"
                        name="date_trx"
                        value={date_trx}
                        onChange={(e) => setDateTrx(e.target.value)}
                        onBlur={(e) => setDateTrx(e.target.value)}
                      />
                    </div>
                  </Form.Row>
                  <Form.Row>
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">ID Transaction</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputTrx_id"
                        placeholder="No  Transaction"
                        name="id_trx"
                        value={id_trx}
                        onChange={(e) => setIdTrx(e.target.value)}
                        onBlur={(e) => setIdTrx(e.target.value)}
                      />
                    </div>
                  </Form.Row>
                  <Form.Row>
                    <Button
                      className="btn-block"
                      style={{ marginTop: "20px", marginBottom: "10px" }}
                      variant="primary"
                      onClick={etapesuivante}
                    >
                      Continuer
                    </Button>
                  </Form.Row>
                </div>
              </Form>
            </>
          )}
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Title>Integration paiement MonCash</Modal.Title>
          <Modal.Body>
            {/* <iframe
              src={moncash_url}
              style={{ width: "100%", height: "400px" }}
              // sandbox="allow-modals allow-forms allow-popups allow-scripts"
            /> */}
            {/* 
            sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
            <div
              dangerouslySetInnerHTML={{ __html: my_iframe ? my_iframe : "" }}
            /> */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="card-footer">
        {/*          
            <div className='d-flex justify-content-between'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Etape precedente
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform + 1)}
              >
                Etape Suivante
              </button>
            </div>
          */}
      </div>
    </div>
  );
};

export default InfoTransaction;
